import React from 'react';
import { Box, Heading, Flex, Button, useColorMode } from '@chakra-ui/core';
import { Link } from 'react-router-dom';
import Search from '../layout/Search';

import main from '../../images/main.jpg';

export default function Hero() {
  const { colorMode } = useColorMode();
  const [scrollState, setScrollState] = React.useState('top');

  React.useEffect(() => {
    let listener = null;
    let isMounted = true;

    listener = document.addEventListener('scroll', e => {
      var scrolled = document.scrollingElement.scrollTop;
      if (scrolled >= 300) {
        if (scrollState !== 'amir' && isMounted) {
          setScrollState('amir');
        }
      } else {
        if (scrollState !== 'top' && isMounted) {
          setScrollState('top');
        }
      }
    });
    return () => {
      document.removeEventListener('scroll', listener);

      isMounted = false;
    };
  }, [scrollState]);
  //    const bgColor = { light: 'red.500', dark: 'red.200' };
  const color = { light: '#EDF2F7', dark: '#141214' };
  return (
    <Box
      className="hero"
      pt="8"
      color="white"
      bg="gray.100"
      bgImage={`linear-gradient(0deg, ${color[colorMode]} 0%, rgba(26,32,44,0) 10%),url(${main})`}
      bgRepeat="no-repeat"
      bgSize="cover"
      height={[
        '450px', // base
        '450px', // 480px upwards
        '450px', // 768px upwards
        '650px', // 992px upwards
      ]}
      width="100%"
    >
      <Flex
        p={[
          '50px', // base
          '80px', // 480px upwards
          '100px', // 768px upwards
          '50px', // 992px upwards
        ]}
        mt="5%"
        // align="left"
        direction="column"
      >
        <Box textAlign="center">
          <Heading
            fontFamily="Rubik Mono One"
            fontSize={[
              '25px', // base
              '50px', // 480px upwards
              '60px', // 768px upwards
              '60px', // 992px upwards
            ]}
            lineHeight={['40px', '50px', '60px', '80px']}
          >
            COMMANDEZ <br /> RETIREZ SANS ATTENDRE{' '}
          </Heading>
        </Box>
        <Flex m="4" justifyContent="center">
          {scrollState === 'top' && <Search></Search>}
        </Flex>
        <Flex justifyContent="center">
          <Link to="/restaurants">
            <Button
              _hover={{ bg: 'red.700' }}
              bg="red.500"
              color="white"
              size="lg"
              rounded="20px"
            >
              Découvrir
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Box>
  );
}
